// ============================================
// MAIN JS FILE
// ============================================

// All modules use IIFE pattern and self-initialize
// This file is the entry point and runs after all modules

document.addEventListener('DOMContentLoaded', () => {
  console.log('Winston v2 initialized');
});
